module.exports = __webpack_public_path__ + "static/media/PCArchiveIcon.72c20c5d.svg";